<template>
  <div class="application-subtitle">
    <div class="subtitle-label">{{field.label}}</div>

    <!-- 处理按钮 -->
    <el-button type="primary" size="small" class="subtitle-btn" v-if="field.showBtn" @click="handleTitleBoxBtnClick">{{field.btnInfo.btnText}}</el-button>
  </div>
</template>

<script>
import utils from '../../../libs/utils';

export default {
  name: 'application-subtitle',
  props: {
    field: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    handleTitleBoxBtnClick() {
      this.field.btnInfo.fields.forEach((field) => {
        this.changeFieldValue(field, this.field.btnInfo.value);
      });
      utils.msg.success('处理完成');
    },

    // 改变字段内容
    changeFieldValue(name, value) {
      this.$emit('fieldValueChanged', {
        name,
        value,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import  '../../../assets/less/variable';
div.application-subtitle {
  font-size: 16px;
  color: @text-dark;
  position: relative;
  line-height: 18px;
  border-bottom: 1px solid @border;
  width: 100%;
  margin: 10px 0 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 38px;
  &::before {
    content: '';
    width: 3px;
    height: 18px;
    background-color: @main;
    border-radius: 1px;
    position: absolute;
    left: -13px;
    top: 50%;
    transform: translateY(-50%);
  }
  .subtitle-label{
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/application-subtitle.vue